import React from "react";
import { Collapse } from "antd";

const { Panel } = Collapse;

const BillingFAQ = () => {
  return (
    <div className="faq-container">
      <h2 className="primary-title" style={{ textAlign: "center" }}>
        Questions fréquentes
      </h2>
      <Collapse defaultActiveKey={["1"]} ghost>
        <Panel
          header="Puis-je mettre fin à mon abonnement à tout moment ?"
          key="1"
        >
          <p>
            Oui, vous pouvez annuler votre abonnement à n'importe quel moment
            depuis l'onglet "Mon compte > Facturation".
          </p>
        </Panel>

        <Panel
          header="Le forfait gratuit est-il gratuit pour toujours ?"
          key="2"
        >
          <p>
            Oui tout à fait ! Vous pouvez ajouter jusqu'a 5 liens sur votre page
            sans rien avoir à dépenser.
          </p>
        </Panel>
        <Panel
          header="Puis-je changer mon abonnement à n’importe quel moment ?"
          key="3"
        >
          <p>
            Oui, vous pouvez passer d’un abonnement supérieur à un abonnement
            inférieur (et inversement) quand vous le souhaitez.
          </p>
        </Panel>
      </Collapse>
    </div>
  );
};

export default BillingFAQ;
